<template>
  <section class="obra-synopsis-card" aria-labelledby="obra-synopsis-title">
    <div class="obra-section-heading">
      <span id="obra-synopsis-title" class="obra-section-heading__eyebrow">Sinopse</span>
    </div>
    <p class="obra-synopsis-card__text" :class="{ 'obra-synopsis-card__text--expanded': expanded }">{{ displayDescription || 'Sinopse ainda nao disponivel.' }}</p>
    <v-btn v-if="canExpand" text small class="obra-synopsis-card__toggle" @click="$emit('toggle-expand')">
      {{ expanded ? 'Mostrar menos' : 'Ler sinopse completa' }}
      <v-icon right small>{{ expanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
    </v-btn>
  </section>
</template>

<script>
export default {
  name: 'ObraSynopsisCard',
  props: {
    description: { type: String, default: '' },
    shortDescription: { type: String, default: '' },
    expanded: { type: Boolean, default: false },
    canExpand: { type: Boolean, default: false },
  },
  computed: {
    displayDescription() {
      return this.expanded ? this.description : this.shortDescription;
    },
  },
};
</script>
